import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = new EncryptStorage('c0d3m@ntr@-accessibilityInsight');


export const reOrderZones = (ev,newCordinates,selectedZoneCoordinates) => {
 
  var currentCord;
console.log('New cordinates : ',newCordinates)
console.log('New cordinates : ev',ev)
let curRedOrd=Number(selectedZoneCoordinates.reading_order);
let dif1 = Number(ev) - curRedOrd
console.log('New cordinates : dif1',dif1)
console.log('New cordinates : sel',selectedZoneCoordinates.reading_order)

  let currentCordTmp = newCordinates.find(coord => coord.id === selectedZoneCoordinates.id
    && coord.xmin ==selectedZoneCoordinates.xmin
    && coord.ymin ==selectedZoneCoordinates.ymin
    && coord.xmax ==selectedZoneCoordinates.xmax
    && coord.ymax ==selectedZoneCoordinates.ymax);

  let prevCord = currentCordTmp.reading_order;
  let diff = ev - currentCordTmp.reading_order
  console.log("New cordinates : Differnce ::",diff);


  let tmpNewCordinates = newCordinates.sort((a,b)=> a.reading_order - b.reading_order)
  for (var i = 0; i < tmpNewCordinates.length; i++) {
    
    currentCord = tmpNewCordinates[i];
    
    if(diff<0)
    { 
       if(currentCord.reading_order>=ev && currentCord.reading_order<=prevCord)
      {
        currentCord.reading_order= parseInt(currentCord.reading_order)+1;
      }
    }
    else
    {
      if(currentCord.reading_order>=ev && currentCord.reading_order>=prevCord){
        currentCord.reading_order= parseInt(currentCord.reading_order)+1;
      }
    }

    if (currentCord.id == selectedZoneCoordinates.id) {
     currentCord.reading_order = ev;
    }
  }

//  newCordinates.splice(currentIndex, 1, currentCord);
console.log("New cordinates : After re-order ::",tmpNewCordinates);
  return tmpNewCordinates
  
  
}